import data from "../../../../../src/Portal/Portal.docs.json";
import * as React from 'react';
export default {
  data,
  React
};